// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.hero-section {
  padding: 4rem 1.5rem 2.5rem;
  text-align: center;
  background: radial-gradient(circle at 50% 20%, #1e293b 0%, #0f172a 70%);
  border-bottom: 1px solid #334155;
}

.hero-badge {
  display: inline-block;
  background-color: rgba(245, 158, 11, 0.15);
  color: #fbbf24;
  font-size: 0.85rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  padding: 0.35rem 1rem;
  border-radius: 9999px;
  border: 1px solid rgba(245, 158, 11, 0.3);
  margin-bottom: 1.25rem;
}

.hero-title {
  font-size: 2.75rem;
  font-weight: 800;
  color: #f8fafc;
  letter-spacing: -0.025em;
  margin-bottom: 1rem;
}

.hero-subtitle {
  max-width: 680px;
  margin: 0 auto;
  font-size: 1.125rem;
  color: #94a3b8;
  line-height: 1.7;
}

.content-container {
  flex: 1 1;
  max-width: 1120px;
  margin: 0 auto;
  padding: 2.5rem 1.5rem;
  width: 100%;
}

.app-footer {
  background-color: #0b1120;
  border-top: 1px solid #1e293b;
  text-align: center;
  padding: 2.5rem 1rem;
  color: #64748b;
  font-size: 0.9rem;
}

.app-footer .sub-note {
  margin-top: 0.4rem;
  font-size: 0.8rem;
  color: #475569;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,uEAAuE;EACvE,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;EAC1C,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,yCAAyC;EACzC,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB","sourcesContent":[".app-container {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.hero-section {\n  padding: 4rem 1.5rem 2.5rem;\n  text-align: center;\n  background: radial-gradient(circle at 50% 20%, #1e293b 0%, #0f172a 70%);\n  border-bottom: 1px solid #334155;\n}\n\n.hero-badge {\n  display: inline-block;\n  background-color: rgba(245, 158, 11, 0.15);\n  color: #fbbf24;\n  font-size: 0.85rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  padding: 0.35rem 1rem;\n  border-radius: 9999px;\n  border: 1px solid rgba(245, 158, 11, 0.3);\n  margin-bottom: 1.25rem;\n}\n\n.hero-title {\n  font-size: 2.75rem;\n  font-weight: 800;\n  color: #f8fafc;\n  letter-spacing: -0.025em;\n  margin-bottom: 1rem;\n}\n\n.hero-subtitle {\n  max-width: 680px;\n  margin: 0 auto;\n  font-size: 1.125rem;\n  color: #94a3b8;\n  line-height: 1.7;\n}\n\n.content-container {\n  flex: 1;\n  max-width: 1120px;\n  margin: 0 auto;\n  padding: 2.5rem 1.5rem;\n  width: 100%;\n}\n\n.app-footer {\n  background-color: #0b1120;\n  border-top: 1px solid #1e293b;\n  text-align: center;\n  padding: 2.5rem 1rem;\n  color: #64748b;\n  font-size: 0.9rem;\n}\n\n.app-footer .sub-note {\n  margin-top: 0.4rem;\n  font-size: 0.8rem;\n  color: #475569;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
